import { render, staticRenderFns } from "./dialog-info.vue?vue&type=template&id=ca23d042&scoped=true"
import script from "./dialog-info.vue?vue&type=script&lang=js"
export * from "./dialog-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca23d042",
  null
  
)

export default component.exports